import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AppBody from "../../components/AppBody";
import {
  rescheduleTakeCall,
  showTakeCall
} from "../../../actions/trainer/assign_trainer_action";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";

const ShowLpTakeCall = () => {
  const dispatch = useDispatch("");
  const state = useSelector((state) => state.assignTrainerReducer);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  const [details, setDetails] = useState({
    title: "",
    start: "",
    id: "",
    end:"",
  });

  const handleClose = () => {
    setShow(false);
    setDetails({
      title: "",
      start: "",
      id: "",
      end:"",
    });
  };

  useEffect(() => {
    dispatch(showTakeCall());
  }, []);

  const showModale = (li) => {
    setDetails({
      title: li.title,
      id: li.id
    });
    setShow(true);
  };
  const handleTakeCallSubmit = () => {
    dispatch(rescheduleTakeCall({ ...details }));
  };
  
  if (state.is_done) {
     dispatch(showTakeCall());
     setShow(false);
  }

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0 shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <Link to={"/completed-trainings"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Take Calls
              </h4>
            </div>
            <div className="card-body p-4 w-100 border-0 ">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Training</th>
                      <th>Title</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.takeCallList &&
                      state.takeCallList.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{li.name}</td>
                          <td>{li.title}</td>
                          <td>{li.start}</td>{" "}
                          <td>{li.end}</td>{" "}
                          <td>
                            <a
                              className="btn approve_btn btn-common"
                              title="Start Take Call"
                              target="_blank"
                            >
                              <i className="feather-play-circle"></i>
                            </a>

                            <a
                              className="btn approve_btn btn-common"
                              title="View Trainers"
                              target="_blank"
                              onClick={() =>
                                navigate("/take-call-trainers/" + btoa(li.id))
                              }
                            >
                              <i className="feather-eye"></i>
                            </a>

                            <a
                              className="btn approve_btn btn-common"
                              title="Reschedule Take Call"
                              target="_blank"
                              onClick={() => showModale(li)}
                            >
                              <i className="fa fa-calendar"></i>
                            </a>

                            <Modal
                              className="custom-modal"
                              show={show}
                              onHide={handleClose}
                              size={"lg"}
                            >
                              <Modal.Header closeButton>
                                <Modal.Title>Reschedule Take Call </Modal.Title>
                              </Modal.Header>
                              <Modal.Body className="err-model-body">
                                <form onSubmit={handleTakeCallSubmit}>
                                  <div className={"row"}>
                                    <div className="col-lg-6 mb-2">
                                      <div className="form-group">
                                        <label className="mont-font fw-600 font-xsss">
                                          Start Date & Time
                                        </label>
                                        <DatePicker
                                          className="form-control"
                                          selected={details.start}
                                          minDate={new Date()}
                                          onChange={(date) =>
                                            setDetails({
                                              ...details,
                                              start: date
                                            })
                                          }
                                          showTimeSelect
                                          dateFormat="Pp"
                                        />
                                        <span className="error-msg">
                                          {state.errors
                                            ? state.errors.start
                                            : ""}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                      <div className="form-group">
                                        <label className="mont-font fw-600 font-xsss">
                                          End Date & Time
                                        </label>
                                        <DatePicker
                                          className="form-control"
                                          selected={details.end}
                                          minDate={new Date()}
                                          onChange={(date) =>
                                            setDetails({
                                              ...details,
                                              end: date
                                            })
                                          }
                                          showTimeSelect
                                          dateFormat="Pp"
                                        />
                                        <span className="error-msg">
                                          {state.errors
                                            ? state.errors.end
                                            : ""}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="col-lg-4 mb-2">
                                      <div className="form-group">
                                        <label className="mont-font fw-600 font-xsss">
                                          Call Title
                                        </label>
                                        <input
                                          placeholder="Enter No Of Participants"
                                          type="text"
                                          className="form-control"
                                          value={details.title}
                                          onChange={(e) =>
                                            setDetails({
                                              ...details,
                                              title: e.target.value
                                            })
                                          }
                                        />
                                        <span className="error-msg">
                                          {state.errors
                                            ? state.errors.title
                                            : ""}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  <div className={"row"}>
                                    <div className="col-lg-12 text-right">
                                      <input
                                        type="submit"
                                        name="submit"
                                        value="Submit"
                                        className="btn-common px-5 mt-15"
                                      />
                                    </div>
                                  </div>
                                </form>
                              </Modal.Body>
                            </Modal>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ShowLpTakeCall;
